// this file is generated by update_shopify_store_data.py at 2026-01-26 20:19:48.966481
var courses = [
    {
        "course_id": "AF0F38A3-9388-EE11-9987-005056A725AD",
        "course_version": 1,
        "name": "ANA: Informatics Nursing Certification (NI-BC\u00ae) PracticeIQ",
        "course_type": 1,
        "author_information": "",
        "description": "Overview\r\nYou will review for the Informatics Nursing Certification exam by quizzing yourself on 200 practice questions covering the areas of:\r\n\r\n - Foundations of Practice\r\n - System Design Life Cycle\r\n - Data Management and Health Care Technology\r\n\r\nYou may choose to go through the PracticeIQ just once or retake it as many times as you want or need. You have the option to practice with the full question set or by Content Domain area. Access is available through the learning portal 24/7.\r\n\r\nANA\u2019s certification prep materials are developed and peer-reviewed by subject-matter experts with advanced education and certified in the specialty.",
        "learning_objectives_html": "<h4>Key Learning Outcomes</h4>\r\n<ul>\r\n    <li>Prepare for the Informatics Nursing Certification (RN-BC&reg;) exam based on the ANCC Test Content Outline effective May 3, 2023</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "C17A92DE-0BEA-E511-B707-005056B16096",
                "course_category_name": "Informatics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 16.6,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];